import React, { useEffect, useRef, useState } from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import { useServices } from '../../hooks/useServices';
import { ElijePago } from '../elige/ElijePago';
import { useHistory } from 'react-router-dom';
import { Facebook} from 'react-spinners-css';
import moment from 'moment';
import 'moment/locale/es';
import { RedUnefon1 } from '../redes/RedUnefon1';
import { Unefon1 } from './Unefon1';
import { UnefonIlimitado2 } from './UnefonIlimitado2';
import { Unefon2 } from './Unefon2';
import { UnefonFlex } from './UnefonFlex';
import { RedIlimitado2 } from '../redes/RedIlimitado2';
import { RedUnefon2 } from '../redes/RedUnefon2';
import { RedFlex } from '../redes/RedFlex';

export const Oferta001 = React.memo(({ data1, lic, pag }) => {

	const { activaSas, activaKairos, guardarDatosPay } = useServices();

	


	const [ofertas, setOfertas] = useState([]);
	const [value, setValue] = useState('');
	const [oferMain, setOfeMain] = useState(true);
	const [licObjeto, setLIC] = useState();
	const [cargando, setCargando] = useState(false);
	const [oferta, setOferta] = useState({});

	const ref = useRef();
	const seleccionado = useRef(false);
	const history = useHistory();

	const redes = useRef();
    const legalTexto = useRef();
    const maximo = useRef();
	const alto = useRef(135);


	// const ofertaGuardada = localStorage.getItem('oa');
	const ofertaGuardada = pag.tsk_id;

	
	let reqLIC = {
		...lic
	}




	

	const editLegal = () => {
		let tiene = false;
        let tiene1 = false;
        let textoLegal = data1.legal;
        //console.log('legal completo: ', textoLegal);
        const indice = textoLegal.indexOf('**');
        const indice1 = textoLegal.indexOf('*');
        
            data1.oferta.map((ofr)=>{
                        ofr.beneficiosOferta.map((of)=>{
                        	
                            if (of.benefitDescription.indexOf('**') > -1 || of.benefitQuantity.indexOf('**') > -1 )
                            { tiene = true;}
                        });
                        ofr.beneficiosBase.map((of)=>{
                        	if (of.benefitDescription.indexOf('*') > -1 || of.benefitQuantity.indexOf('*') > -1)
                            { tiene1 = true;}
                        });
                        
                    });
        
                    if (tiene == false && data1.planId !== 4){
                        textoLegal = textoLegal.slice(0, indice);
                    }
                    if (tiene1 == false){
                        textoLegal = textoLegal.slice(indice, -1);
                    }
				const texto = data1.legal.replaceAll("|","\n");
				legalTexto.current =  `${texto}`;
	}

	const getLen = () => {
			let lens= [];
			data1.oferta.map((ofr)=>{
				lens = [...lens,ofr.beneficiosBase.length ]
			});
			const max = Math.max.apply(null, lens);
			maximo.current= max;
	}

	//    planId :
// 1 - unefon ilimitado 1
// 2 - unefon 2
// 3 - unefon ilimitado 2
// 4 - unefon flex
const tipoOferta = (ofertaParam) => {
	darEspacios(ofertaParam);
	quitarEspacios(ofertaParam);
	switch (data1.planId) {
		case 1:
			return <Unefon1  oferta1={ofertaParam}/>
		break;
		case 2:
			return <UnefonIlimitado2  oferta1={ofertaParam}/>
		break;
		case 3:
			return <Unefon2  oferta1={ofertaParam}/>
		break;
		case 4:
			return <UnefonFlex  oferta1={ofertaParam}/>
		break;
		default:
			console.log('no existe planId');
			break;
	}
}

const altosRedes = (ofertaParam) => {
	switch (data1.planId) {
		case 1:
			redes.current = <RedUnefon1/>
		break;
		case 2:
			alto.current = 120;
			redes.current = <RedIlimitado2/>
		break;
		case 3:
			alto.current = 175;
			redes.current = <RedUnefon2/>
		break;
		case 4:
			redes.current = <RedFlex/>
		break;
		default:
			console.log('no existe planId');
			break;
	}
}

const quitarEspacios = (oferta) =>{
	oferta.beneficiosBase.map((of)=>{
		if(!of.benefitQuantity.includes("*")){
        	legalTexto.current =  ``;
        	}
		of.benefitDescription = of.benefitDescription.replace(/\s*(.*?)\s*\*/g,'$1*');
	});
}

const darEspacios = (oferta) =>{
	oferta.beneficiosBase.map((of)=>{
		of.topupAmount = oferta.topupAmount;
		//le quito las comas que vienen entre dos digitos
		of.benefitQuantity = of.benefitQuantity.replace(/(\d),(?=\d)/g,'$1');
		//sustituyo las comas por coma y un espacio
	   of.benefitQuantity = of.benefitQuantity.split(',').join(', ');
	});
}



const ordenarOfertas = () => {
	let promos = [];
	return new Promise((resolve,reject)=>{
	   data1.oferta.map((ofr)=>{
		promos = [...promos, ofr.topupAmount];
		promos.sort(function(a, b){return a-b});
			ofr.beneficiosBase.map((of)=>{
				ofr.validity = of.validity;
			});
		});
		ref.current = promos
		resolve();
	});
   
}


	const ordenarOfertas2 = async () => {
		let promos = [];
		await ordenarOfertas();
		data1.oferta.map((ofr) => {
			
				ofr.topupAmount = (~~ofr.topupAmount)+"";
				if (ofertaGuardada === ofr.tskId) {
					ofr.seleccionado = true;
					setOferta({ ...ofr });
					setValue(ofr.topupAmount);
					promos = [...promos, ofr];
				} else {
					promos = [...promos, ofr];
				}

			
		});
		promos.sort(function (a, b) {
			return a.topupAmount - b.topupAmount;
		  });
		setOfertas(promos);
	}

	async function seleccionaOferta() {
		//console.log('oferta seleccionada: ', oferta);
		if (data1.dn) {
			seleccionado.current = true;
			if (data1.crm === "SAS") {
				const sas = {
					"mdn": data1.dn,
					"tksId": oferta.tskId,
					"redeemedTime": moment().format()
				}
				//console.log('oferta a activar sas: ', sas);
				setOfeMain(false);

				const respuestaActivacion = await activaSas(sas);
				console.log('respuesta: activate', respuestaActivacion);
				
				if (respuestaActivacion) {
					if (respuestaActivacion.status) {
						//console.log('error activar SAS:', respuestaActivacion.status);
						history.push("/error");

					} else {
						//console.log('SAS: ', respuestaActivacion);

						if (respuestaActivacion.code == 0) {
							localStorage.setItem('oa', oferta.tskId);
							setCargando(true);
							guardaDataPay();
						} else {
							//console.log('error activar SAS:', respuestaActivacion);
							history.push("/error");
						}
					}

				} else {
					//console.log('error activar SAS 2: ', respuestaActivacion);
					history.push("/error");
				}


			} else {
				const kairos = {
					"mdn": data1.dn,
					"tksId": oferta.tskId,
					"diasVigencia": data1.diasVigencia,
					"redeemedTime": moment().format()
				}
				//console.log('oferta a activar kairos: ', kairos);
				setOfeMain(false);
				const respuestaActivacion = await activaKairos(kairos);

				if (respuestaActivacion) {
					if (respuestaActivacion.status) {
						//console.log('error activar Kairos:', respuestaActivacion.status);
						history.push("/error");

					} else {
						//console.log('Kairos: ', respuestaActivacion);

						if (respuestaActivacion.code == 0) {
							localStorage.setItem('oa', oferta.tskId);
							setCargando(true);
							
							guardaDataPay();
						} else {
							//console.log('error activar Kairos:', respuestaActivacion);
							history.push("/error");
						}
					}
				} else {
					//console.log('error activar Kairos 2: ', respuestaActivacion);
					history.push("/error");
				}

			}
		} else {
			seleccionado.current = false;
		}
	}

	async function guardaDataPay() {
		const cantidad = pag.topup_amount;
		const numero = pag.mdn;
		const payloadBit = {
			"mdn": pag.mdn,
			"tskId": pag.tsk_id,
			"topupAmount": Number(cantidad),
			"redeemedTime": moment().format()
		}

		console.log('guardamos oferta: ', payloadBit);

		const respuestaBitacora = await guardarDatosPay(payloadBit);
		if (respuestaBitacora) {
			const trans_id = pag.transaction_id;
			if (respuestaBitacora.status) {
				//console.log('error guardar bitacora:', respuestaBitacora);
				reqLIC = {
					...lic,
					"dn": Number(numero),
					"transactionExtId": trans_id + "",
					"chargeAmount": Number(cantidad),
				}
				reqLIC.paymentDetail[0].amount = Number(cantidad);
				setLIC(reqLIC);
			} else {
				reqLIC = {
					...lic,
					"dn": Number(numero),
					"transactionExtId": trans_id + "",
					"chargeAmount": Number(cantidad),
				}
				reqLIC.paymentDetail[0].amount = Number(cantidad);
				setLIC(reqLIC);
				//console.log('LIC estado: ', licObjeto);
			}
		} else {
			//console.log('error guarda: ', respuestaBitacora);
		}

	}


	let fechaVigencia = data1.fechaVigencia;
    fechaVigencia = moment(fechaVigencia).locale('es').format('LL');


	useEffect(() => {
		altosRedes();
		ordenarOfertas2();
		editLegal();
        getLen();

	}, [data1]);



	return (
		<div>
			{
				oferMain === true
					? <div>
						<div className="promo activada">

							<div className="titulo">Seleccionaste esta oferta</div>

							<p>Hubo un problema para activar tu promoción, por favor actívala presionando el botón</p>

							<FormControl component="fieldset" className="contenedorFormas animate__animated animate__fadeIn" >
								<RadioGroup row className="contenedorUnefon" >
								{
                                    ofertas.map( (offer, i) => (

                                        
                                        <div className={offer.seleccionado === true ? "ofertaM2" : "ofertaM"} key={ i } style={{height : maximo.current * alto.current +"px"}} >
                                           
                                           
                                            <div className="cantidadOferta">${offer.topupAmount}</div>
                                            { 
                                            data1.planId === 3 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            { 
                                            data1.planId === 4 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            {tipoOferta(offer)}
                                        </div>
                                        
                                        )
                                    )
                                }
								</RadioGroup>
							</FormControl>

						</div>
						<div className="conteRedes">
                                {redes.current}
                    	</div>
						<div className="btn" onClick={seleccionaOferta}>Activar oferta</div>




						<div className="textoRedes">
						{legalTexto.current}
						<div>Consulta coberturas, términos y condiciones de la oferta en unefon.com.mx</div>
						</div>
					</div>
					: cargando === false ? <div className="spinner"><Facebook color="#594498" /></div> : <ElijePago cantidad={value} vigencia={fechaVigencia} lic1={licObjeto} />
			}

		</div>
	)
})
